import type { Dispatch, SetStateAction } from 'react';
import { createContext, useContext } from 'react';

import type { PickerSize } from '../pickerPrimitiveStyles';

type ComboboxContextValue = {
  size: PickerSize;
  isLoading?: boolean;
  error?: Error | null;
  disabled?: boolean;
  chipsAnchor: HTMLDivElement | null;
  setChipsAnchor: Dispatch<SetStateAction<HTMLDivElement | null>>;
  inputAnchor: HTMLDivElement | null;
  setInputAnchor: Dispatch<SetStateAction<HTMLDivElement | null>>;
};

const ComboboxContext = createContext<ComboboxContextValue | null>(null);

const defaultContextValue: ComboboxContextValue = {
  size: 'large',
  isLoading: false,
  error: null,
  disabled: false,
  chipsAnchor: null,
  setChipsAnchor: () => {},
  inputAnchor: null,
  setInputAnchor: () => {},
};

export const useComboboxContext = () => useContext(ComboboxContext) ?? defaultContextValue;

export default ComboboxContext;
